import script from "./cashBackHistoryCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./cashBackHistoryCard.vue?vue&type=script&lang=ts&setup=true"

import "./cashBackHistoryCard.vue?vue&type=style&index=0&id=4bc251ed&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bc251ed"]])

export default __exports__